export default {"src":"/_next/static/media/language.b03e9ad5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};